<main>
    <div class="container main">
        <form>
            <h1>Editar Produto</h1>
            <div class="row">
                <div class="col">
            <label id="label-input" for="name">
                <span>Nome:</span>
                <input class="input form-control" [(ngModel)]="produto.vc_nome" type="text" name="produto.vc_nome" id="name">
            </label>
        </div>
    </div>
            <div id="buttons">
                <button (click)="atualizar()" class="btn-sucesso" type="btn">Salvar</button>
                <button (click)="cancel()" class="btn-cancelar" type="btn">Cancelar</button>
            </div>
        </form>
    </div>
</main>